import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

const defaultValue = {
  isSiteNavMenuOpen: false,
  openSiteNavMenu: () => {},
  closeSiteNavMenu: () => {},
};

const SiteNavMenuContext = createContext(defaultValue);

/**
 * Site hamburger menu state. Opening the menu must not push a history entry,
 * so Browser Back after a nav item returns to the previous page — not the overlay.
 */
export const SiteNavMenuProvider = ({ children }) => {
  const location = useLocation();
  const [isSiteNavMenuOpen, setOpen] = useState(false);

  const openSiteNavMenu = useCallback(() => setOpen(true), []);
  const closeSiteNavMenu = useCallback(() => setOpen(false), []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const value = useMemo(
    () => ({ isSiteNavMenuOpen, openSiteNavMenu, closeSiteNavMenu }),
    [isSiteNavMenuOpen, openSiteNavMenu, closeSiteNavMenu]
  );

  return <SiteNavMenuContext.Provider value={value}>{children}</SiteNavMenuContext.Provider>;
};

export const useSiteNavMenu = () => useContext(SiteNavMenuContext);
